import { Card, CardContent, CardHeader, CardTitle } from "./ui/Card";
import { PieChart, Pie, Cell, ResponsiveContainer, Legend } from "recharts";

interface DonutChartProps {
  data: {
    sold: { value: number; count: number };
    cancelled: { value: number; count: number };
  } | null;
}

export function DonutChart({ data }: DonutChartProps) {
  const chartData = data ? [
    { name: 'Vendido', value: Number(data.sold.value), count: Number(data.sold.count), color: '#849D70' },
    { name: 'Cancelado', value: Number(data.cancelled.value), count: Number(data.cancelled.count), color: '#C2452D' },
  ] : [];

  const RADIAN = Math.PI / 180;

  const renderCustomizedLabel = ({
    cx, cy, midAngle, innerRadius, outerRadius, percent
  }: any) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <text
        x={x}
        y={y}
        fill="white"
        textAnchor={x > cx ? 'start' : 'end'}
        dominantBaseline="central"
        fontSize="12"
        fontWeight="600"
      >
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    );
  };

  const CustomLegend = (props: any) => {
    const { payload } = props;
    return (
      <div className="flex flex-col space-y-2 mt-4">
        {payload.map((entry: any, index: number) => {
          return (
            <div key={`item-${index}`} className="flex items-center space-x-2">
              <div
                className="w-3 h-3 rounded-full"
                style={{ backgroundColor: entry.color }}
              />
              <span className="text-sm text-[#68686A]">{entry.value} ({entry.payload.count})</span>
            </div>
          );
        })}
      </div>
    );
  };

  const total = chartData.reduce((sum, item) => sum + item.count, 0);

  return (
    <Card className="border border-gray-200 hover:shadow-md transition-shadow duration-200">
      <CardHeader>
        <CardTitle className="text-[#68686A] text-md font-bold">Status das Vendas</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="h-80">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={chartData}
                cx="50%"
                cy="50%"
                labelLine={false}
                label={renderCustomizedLabel}
                outerRadius={80}
                innerRadius={40}
                fill="#8884d8"
                dataKey="count"
              >
                {chartData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
              <Legend content={<CustomLegend />} />
            </PieChart>
          </ResponsiveContainer>
        </div>
        <div className="text-center mt-4">
          <p className="text-2xl font-semibold text-gray-900">{total}</p>
          <p className="text-sm text-[#68686A]">Total</p>
        </div>
      </CardContent>
    </Card>
  );
}